import React from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
} from "antd";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "Common/Footer";

import useUserInvite from "Hooks/AdminHooks/useUserInvite";
import { ToastContainer } from "react-toastify";

const { Text } = Typography;

const UserInvite = () => {
  const [form] = Form.useForm();
  const { loading, invites, sendUserInvitation } = useUserInvite();

  const onFinish = (values) => {
    sendUserInvitation(values.email);
    form.resetFields();
  };

  // ✅ STATUS LOGIC
  const getStatus = (item) => {
    const now = new Date();
    const expiry = new Date(item.expiresAt);

    if (item.used === true) {
      return "Accepted";
    }

    if (item.used === false && expiry > now) {
      return "Pending";
    }

    if (item.used === false && expiry <= now) {
      return "Expired";
    }

    return "Pending";
  };

  const getStatusTag = (status) => {
    switch (status) {
      case "Accepted":
        return <Tag color="green">Accepted</Tag>;
      case "Pending":
        return <Tag color="blue">Pending</Tag>;
      case "Expired":
        return <Tag color="red">Expired</Tag>;
      default:
        return <Tag>Unknown</Tag>;
    }
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        const status = getStatus(record);
        return getStatusTag(status);
      },
    },
    {
      title: "Expiry Date",
      dataIndex: "expiresAt",
      key: "expiresAt",
      render: (date) =>
        date ? new Date(date).toLocaleString() : "-",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Invite Form */}
      <Card
        title="Invite User"
        className="card-professional"
        style={{ marginBottom: 20 }}
      >
        <Form form={form} layout="inline" onFinish={onFinish}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Enter valid email" },
            ]}
          >
            <Input placeholder="Please Enter email" />
          </Form.Item>

          <Form.Item>
            <Button
              className="btn-primary"
              htmlType="submit"
              loading={loading}
            >
              Send Invite
            </Button>
          </Form.Item>
        </Form>
      </Card>

      {/* Invite Table */}
      <Card title="My Invites">
        {loading ? (
          <Spin />
        ) : (
          <Table
            dataSource={invites}
            columns={columns}
            rowKey="userId"
            pagination={{ pageSize: 5 }}
          />
        )}
      </Card>

      <Footer />
    </DashboardLayout>
  );
};

export default UserInvite;